import { initializeApp } from 'firebase/app';
import {
  CACHE_SIZE_UNLIMITED,
  enableNetwork,
  initializeFirestore,
} from 'firebase/firestore';

// Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore with settings
export const db = initializeFirestore(app, {
  cacheSizeBytes: CACHE_SIZE_UNLIMITED,
});

enableNetwork(db).catch((error) => {
  console.error('Failed to enable Firestore network:', error);
});

export default app;
